import { updateAndOrQueue } from "shared/middleware/waitForId/waitForIdSlice";

export const deleteItemThunkAction = (payload) => (dispatch, getState) => {
  if (payload.method.type === "openItem") {
    const state = getState().itemLists;
    payload.index = state.openItem.index;
    payload.id = state.openItem.details.id;
  }
  const { id } = payload;
  const effect = {
    url: "items",
    id,
    method: "DELETE",
  };
  const updateAction = {
    type: "itemLists/deleteItem",
    payload,
    meta: {
      offline: {
        effect: effect,
        commit: { type: "itemLists/deleteItem.commit" },
      },
    },
  };
  updateAndOrQueue({
    dependsOn: "itemLists/saveNewTask.commit",
    id,
    effect,
    updateAction,
    dispatch,
  });
};

export function deleteItemCaseLogic(state, action) {
  state.needsReload = removeItemFromState(state, action.payload);
  state.openItem.isOpen = false;
  state.status = "pending";
}

function removeItemFromState(state, payload) {
  const { attributes, method, isDueItem } = payload;

  switch (method.type) {
    case "openItem":
      return removeItemFromStateWithOpenItem({ state, attributes, isDueItem });
    case "swipe":
      return removeItemFromStateFromSwipe({ state, ...payload });
  }
}

function removeItemFromStateWithOpenItem({ state, isDueItem }) {
  const openItem = state.openItem;
  const nr = needsReload(openItem.details.type);

  // if(nr){
  //     updatedItem.isPending = true
  // }
  let items;
  if (state.openItem.isDone) {
    items = state.doneItems;
  } else {
    items = isDueItem ? state.dueItems : state.items;
  }
  items.splice(openItem.index, 1);
  return nr;
}

function removeItemFromStateFromSwipe({
  state,
  isDueItem,
  index,
  isDone,
  itemType,
}) {
  const nr = needsReload(itemType);
  let items;
  if (isDone) {
    items = state.doneItems;
  } else {
    items = isDueItem ? state.dueItems : state.items;
  }
  items.splice(index, 1);
  return nr;
}

function needsReload(type) {
  return type === "calendar_note" || type === "continuing_calendar_note";
}
